import { Controller } from "@hotwired/stimulus";
import { trapNestedModal } from "../utils/FocusTrap";
import { seemsOffline } from "../utils/connectivity";

// Connects to data-controller="todo-button"
export default class extends Controller {
  static values = {
    url: String,
    caseName: String,
    timeOnCase: String,
  };

  static outlets = ["offline-navigation"];

  async save(event) {
    event.preventDefault();
    if (seemsOffline()) {
      if (this.hasOfflineNavigationOutlet) {
        this.offlineNavigationOutlet.showFeatureUnavailable(this.element);
      }
      return;
    }
    const url = this.urlValue;
    const caseName = this.caseNameValue;
    const timeOnCase = this.timeOnCaseValue;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        console.log(`Failed to save quiz to do: ${response.status} ${response.statusText}`);
        return;
      }
      const html = await response.text();
      if (window.Turbo && Turbo.renderStreamMessage) {
        await Turbo.renderStreamMessage(html);
      }
      const el = document.getElementById("todo_form_container");
      const parentModal = document.getElementById("finish_card_modal");
      const trigger = event.currentTarget;
      if (el) {
        requestAnimationFrame(() => {
          trapNestedModal(parentModal, el, {
            trigger,
            initialFocusSelector: ".select-list-save-quiz-todo-modal",
          });
        });
      }
      if (window.analytics && typeof window.analytics.track === "function") {
        window.analytics.track("saq_save_to_do", {
          page: window.location.href,
          source: "Case Page",
          case_name: caseName,
          time_on_case: timeOnCase,
        });
      }
    } catch (e) {
      // Optionally handle error
    }
  }
}
